var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVodvilWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 370.7,
    y: 668.5,
    className: "st0",
    width: 59.7,
    height: 89.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M589.7,458.4c11.3-12.4,23.9-22.6,37.5-31.1c-8.7-6.4-17-13.7-24.7-22C505.1,301,519.3,79.1,519.9,69.8V42 H281.2v29.8c0.6,7.3,14.8,229.2-82.5,333.6c-7.8,8.3-16,15.5-24.7,22c13.6,8.5,26.2,18.7,37.5,31.1 c85.1,93.2,70.4,265.2,69.7,272.5V758H311V638.7c0-16.5,13.4-29.8,29.8-29.8h119.3c16.5,0,29.8,13.4,29.8,29.8V758h29.8v-29.8 C519.3,723.6,504.6,551.6,589.7,458.4z M494.3,324L377.4,505.9V389.1H319c-9,0-15.9-8.1-14.4-17l24.3-145.9 c1.2-7,7.3-12.2,14.4-12.2h75.2c9,0,15.9,8.1,14.4,17l-11.8,70.6H482C493.5,301.5,500.5,314.3,494.3,324z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M728.7,42H579.5v29.8c-0.2,4.1-13.1,207.6,66.6,292.9c22.2,23.7,49.2,35.3,82.6,35.3h29.8V71.8 C758.5,55.4,745.2,42,728.7,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155,364.7c66.3-71,70.6-234,66.6-290.8V42H72.3c-16.5,0-29.8,13.4-29.8,29.8V400h29.8 C105.8,400,132.8,388.5,155,364.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M633.8,498.5c-67.4,73.7-54.6,225.4-54.4,226.9l0,32.5h149.3c16.5,0,29.8-13.4,29.8-29.8V459.7h-29.8 C688.8,459.7,657.8,472.4,633.8,498.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.3,459.7H42.5v268.5c0,16.5,13.3,29.8,29.8,29.8h149.2v-29.8c0.3-4.2,13-156-54.3-229.6 C143.2,472.4,112.2,459.7,72.3,459.7z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVodvilWhiteLogo);
export default __webpack_public_path__ + "static/media/vodvil-white-logo.1172cbb38a0ea82e1d550b20776ed404.svg";
export { ForwardRef as ReactComponent };